import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { usePAChecklistFollowUp } from '../pa_checklist_followup_context';
import styles from '../pa_checklist_followup.module.scss'
import Tabela from '../../../Misc/Tabela/Tabela';
import { toBrDateWithTime } from '../../../../utils/dateUtils';
import MaterialIconsReact from 'material-icons-react';
import { api } from '../../../../services/api';
import { toast } from 'react-toastify';
import { useMisc } from '../../../../contexts/MiscContext';
import PAChecklistModalLocalizacao from '../../Checklist/components/pa_checklist_modal_localizacao';

const PAChecklistFollowUpInfoTab = () => {
  const { itemSelecionado, infoComp, isAdmin, usuarioAdminFup, setShowModalHistoricoReanalise } = usePAChecklistFollowUp();
  const [observacoesCQ, setObservacoesCQ] = useState('');
  const { setShowLoading } = useMisc();

  const [pilotoProducao, setPilotoProducao] = useState({});
  const [pilotoMostruario, setPilotoMostruario] = useState({});
  const [showModalLocalizacao, setShowModalLocalizacao] = useState(false);

  useEffect(() => {
    if (itemSelecionado.observacoes_cq) setObservacoesCQ(itemSelecionado.observacoes_cq);
  }, []);

  const updateObservacoesCQ = async () => {
    try {
      const params = {
        observacoesCQ,
        id_entrada_fiscal: itemSelecionado.id_entrada_fiscal
      }

      setShowLoading(true);
      await api.post('pa/checklist-fup/update-observacoes-cq', params);
      toast.success('Observações atualizadas com sucesso.');
    } catch (e) {
      toast.error('Ocorreu um erro ao alterar as observações.\nPor favor tente novamente.')
    } finally {
      setShowLoading(false);
    }
  }

  const calcStatusAnalise = (analiseOk) => {
    if (!analiseOk) return ' - ';

    const numDir = itemSelecionado?.analiseDirecionamentos?.length || 0;
    const numMed = itemSelecionado?.analiseMedidas?.length || 0;

    let str = '';
    if (numDir === 0) str += 'NENHUM DIRECIONAMENTO INSERIDO - ';
    if (numDir > 0) str += `${numDir} DIRECIONAMENTO(S) INSERIDO(S) - `;
    if (numMed === 0) str += 'NENHUMA MEDIÇÃO INSERIDA';
    if (numMed > 0) str += `${numMed} MEDIÇÕES(S) INSERIDA(S)`;
    return str;
  }

  const procData = [
    {
      label: `${itemSelecionado.dispensa_parcial || itemSelecionado.dispensa_total ? 'Revisão Análise (Dispensada)' : 'Revisão Análise'}`,
      value: itemSelecionado.revisao_ok,
      data: toBrDateWithTime((itemSelecionado.data_revisao)),
      status: itemSelecionado.status_revisao || '-',
      user: itemSelecionado.usuario_responsavel_revisao || '-'
    },
    {
      label: `${itemSelecionado.dispensa_total ? 'Abertura de Caixa e Conferência de Romaneio (Dispensada)' : 'Abertura de Caixa e Conferência de Romaneio'}`,
      value: itemSelecionado.conferencia_caixa_ok,
      data: toBrDateWithTime((itemSelecionado.data_conferencia_caixa)),
      status: itemSelecionado.romaneio_nf_saida ? `ROMANEIO ACATADO: ${itemSelecionado.romaneio_nf_saida}` : '-',
      user: itemSelecionado.usuario_responsavel_conferencia_caixa || '-'
    },
    {
      label: `${itemSelecionado.dispensa_total ? 'Checklist Análise e Medidas (Dispensada)' : 'Checklist Análise e Medidas'}`,
      value: itemSelecionado.analise_ok,
      data: toBrDateWithTime((itemSelecionado.data_analise)),
      status: calcStatusAnalise(itemSelecionado.analise_ok),
      user: itemSelecionado.usuario_responsavel_analise || '-'
    },
    {
      label: `${itemSelecionado.dispensa_total ? 'Prova de Roupa (Dispensada)' : 'Prova de Roupa'}`,
      value: itemSelecionado.prova_de_roupa_ok,
      data: toBrDateWithTime((itemSelecionado.data_prova_de_roupa)),
      status: itemSelecionado.status_prova_roupa || '-',
      user: itemSelecionado.usuario_responsavel_prova_de_roupa || '-'
    },
    {
      label: 'Resultado Final',
      value: itemSelecionado.finalizacao_ok,
      data: toBrDateWithTime((itemSelecionado.data_finalizacao)),
      status: itemSelecionado.status_final || '-',
      user: itemSelecionado.usuario_responsavel_finalizacao || '-'
    },
  ];

  const procColumns = [
    {
      name: 'Item', selector: row => {
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            {row.value ?
              <MaterialIconsReact icon="check_circle" size={20} color='#35B86F' /> :
              <MaterialIconsReact icon="error" size={20} color='#F23C3C' />
            }
            <div>{row.label}</div>
          </div>
        )
      },
      style: { justifyContent: 'left' }
    },
    { name: 'Resumo', selector: row => row.status },
    { name: 'Data Confirmação', selector: row => row.data },
    { name: 'Usuário', selector: row => row.user }
  ];

  useEffect(() => {
    for (const item of itemSelecionado?.checklistDataPiloto) {
      if (item.id_tipo === 1) setPilotoProducao({ ...item });
      if (item.id_tipo === 2) setPilotoMostruario({ ...item });
    }
  }, []);

  return (
    <section className={styles.info_wrapper}>
      <div>
        <Tabela
          columns={procColumns}
          data={procData}
          pagination={false}
          highlightOnHover={true}
          customStylesOverrider={{
            headCells: { style: { backgroundColor: '#FFF', justifyContent: 'center', color: '#000' } },
            cells: { style: { justifyContent: 'center' } },
            rows: { style: { maxHeight: '40px', minHeight: '40px', overflow: 'hidden' } }
          }}
        />
      </div>

      <div className={styles.separator} />

      <section className={styles.info_col_wrapper}>
        <div className={styles.info_col} style={{ width: '40%' }}>
          <span className={styles.info_value}>{itemSelecionado.filial_revisao} | {itemSelecionado.marca} | {toBrDateWithTime(itemSelecionado.data_registro)}</span>
          {infoComp('Arara', itemSelecionado.arara || '-')}
          {infoComp('Desenvolvimento', itemSelecionado.dev_interno ? 'Interno' : 'Externo')}
          {infoComp('Digitalização', itemSelecionado.digitalizacao_interna ? 'Interna' : 'Externa')}
          {infoComp('Status Produto', itemSelecionado.status_produto || '-')}
          {infoComp('Lacre', toBrDateWithTime(itemSelecionado.data_lacre) || '-')}
          {infoComp('Piloto Lacrada Linx', itemSelecionado.estoque_piloto_lacrada || '-')}
          {infoComp('Data Piloto Lacrada Linx', toBrDateWithTime(itemSelecionado.data_estoque_piloto_lacrada) || '-')}
          {infoComp('Composição', itemSelecionado.composicao_linx || '-')}
          {infoComp('Piloto Visual Linx', itemSelecionado.estoque_piloto_visual || '-')}
          {infoComp('Data Piloto Visual Linx', toBrDateWithTime(itemSelecionado.data_estoque_piloto_visual) || '-')}
          {infoComp('Programação', itemSelecionado.programacao || '-')}
          {infoComp('Mês/Quinzena Programação', itemSelecionado.mes_quinzena_prog || '-')}
          {infoComp('Coleção Ajustada', itemSelecionado.colecao_ajustada || '-')}
          {infoComp('Estilista', itemSelecionado.estilista || '-')}
        </div>
        <div className={styles.vertical_separator_full} />
        <div className={styles.info_col}>
          <span style={{ fontWeight: '500', textDecoration: 'underline' }}>Produção</span>
          {infoComp('Estoque Atual Piloto Lacrada PLM', pilotoProducao.estoque || '-')}
          {infoComp('Localização Piloto Lacrada PLM', pilotoProducao.localizacao || '-')}
          {infoComp('Data Piloto Lacrada PLM', toBrDateWithTime(pilotoProducao.data_cadastro) || '-')}
          <span style={{ fontWeight: '500', textDecoration: 'underline' }}>Mostruário</span>
          {infoComp('Estoque Atual Piloto Visual PLM', pilotoMostruario.estoque || '-')}
          {infoComp('Localização Piloto Visual PLM', pilotoMostruario.localizacao || '-')}
          {infoComp('Data Piloto Visual PLM', toBrDateWithTime(pilotoMostruario.data_cadastro) || '-')}
          <Button
            onClick={() => setShowModalLocalizacao(true)}
            style={{ fontWeight: '500', marginTop: '10px' }}
          >
            Localizações
          </Button>
          <Button
            onClick={() => setShowModalHistoricoReanalise(true)}
            variant='warning'
            style={{ fontWeight: '500' }}
          >
            Histórico de Alterações
          </Button>
        </div>
        <div className={styles.vertical_separator_full} />
        <div className={styles.info_col}>
          {infoComp('Responsável PCP', itemSelecionado.responsavel_pcp || '-')}
          {infoComp('Prazo de pagamento', itemSelecionado.condicao_pagamento || '-')}
          {infoComp('Indica Segunda Qualidade', itemSelecionado.nf_segunda_qualidade ? 'Sim' : 'Não')}
          {infoComp('Tipo Produto', itemSelecionado.tipo_produto || '-')}
          {infoComp('Linha', itemSelecionado.linha || '-')}
          {infoComp('Coleção', itemSelecionado.colecao || '-')}
          {infoComp('Desc. Produto', itemSelecionado.descricao_produto || '-')}
          {infoComp('Fornecedor', itemSelecionado.origem || '-')}
          {infoComp('Consumiu Tecido de Mostruário', itemSelecionado.consumiu_mostruario ? 'Sim' : 'Não')}
        </div>
        <div className={styles.vertical_separator_full} />
        <div className={styles.info_col}>
          {infoComp('Data Entrada Revisao', toBrDateWithTime(itemSelecionado.data_entrada_revisao) || '-')}
          {infoComp('OP/Pedido', itemSelecionado.ordem_producao || '-')}
          {infoComp('Nota Fiscal', itemSelecionado.nf_entrada || '-')}
          {infoComp('Série NF', itemSelecionado.serie_nf || '-')}
          {infoComp('Qtde. Entrada', itemSelecionado.qtde_entrada || '-')}
          {infoComp('Houve Dispensa Parcial', itemSelecionado.dispensa_parcial || '-')}
          {infoComp('Houve Dispensa Total', itemSelecionado.dispensa_total || '-')}
          <span style={{ fontWeight: '500', textDecoration: 'underline', marginTop: '10px', textAlign: 'center' }}>
            Chamados
          </span>
          {itemSelecionado?.listaChamados?.map((item, index) => {
            return (
              <div key={index}>
                Chamado {item.id_divergencia} |&nbsp;
                <a
                  href={`https://plm-colaborativo.somalabs.com.br/produtos/${item.id_producao_prog_prod}/${item.id_producao_ppp_op}/divergencias?open=${item.id_divergencia}`}
                  target={'_blank'}
                  rel={'noopener noreferrer'}
                >
                  abrir chamado
                </a>
              </div>
            );
          })}
          {itemSelecionado.listaChamados.length === 0 &&
            <div className={styles.section_label}>Nenhum chamado encontrado</div>
          }
        </div>
      </section>

      <div className={styles.separator} />

      <section className={styles.info_obs_wrapper}>
        <div className={styles.info_textarea}>
          <Form.Group className={styles.sub_form_label}>
            <Form.Label style={{ fontWeight: '500' }}>Observações Controle de Qualidade</Form.Label>
            <Form.Control
              as={'textarea'}
              placeholder={'Insira aqui quaisquer observações adicionais sobre os resultados do controle de qualidade.'}
              rows={6}
              value={observacoesCQ || ''}
              onChange={e => setObservacoesCQ(e.target.value)}
            />
          </Form.Group>
          <Button
            variant={'success'}
            className={styles.footer_btn_processamento}
            onClick={() => updateObservacoesCQ()}
            style={{ marginTop: '10px' }}
            disabled={!isAdmin && !usuarioAdminFup}
          >
            Salvar Alterações
          </Button>
        </div>
        <div className={styles.info_textarea}>
          <Form.Group className={styles.sub_form_label}>
            <Form.Label style={{ fontWeight: '500' }}>Observações PCP</Form.Label>
            <Form.Control
              as={'textarea'}
              placeholder={'Nenhuma observação inserida pelo PCP.'}
              rows={6}
              value={itemSelecionado.observacoes_pcp}
              disabled
            />
          </Form.Group>
        </div>
      </section>
      {showModalLocalizacao &&
        <PAChecklistModalLocalizacao
          produto={itemSelecionado.produto}
          cor_produto={itemSelecionado.cor_produto}
          localizacoes={itemSelecionado.checklistDataLocalizacao}
          showModalLocalizacao={showModalLocalizacao}
          setShowModalLocalizacao={setShowModalLocalizacao}
        />
      }
    </section>
  );
}

export default PAChecklistFollowUpInfoTab;
